import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isHome ? 'bg-transparent' : 'bg-background-50/95 backdrop-blur-md'}`} id="navbar">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-950 font-heading">91抖音</span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'}`}>首页</Link>

              <div className="relative" onMouseEnter={() => setCategoryOpen(true)} onMouseLeave={() => setCategoryOpen(false)}>
                <button className="flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer text-foreground-700 hover:text-foreground-950 transition-colors">
                  分类浏览
                  <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {categoryOpen && (
                  <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
                    <div className="bg-background-50 rounded-lg p-2 min-w-[200px] grid grid-cols-2 gap-1">
                      {categories.map((cat) => (
                        <Link
                          key={cat.slug}
                          to={`/category/${cat.slug}`}
                          className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          <i className={`${cat.icon} text-base text-primary-500`}></i>
                          {cat.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <Link to="/about" className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'}`}>关于我们</Link>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <a href="#download" className="px-4 py-2 text-sm font-medium whitespace-nowrap cursor-pointer rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors">
                立即下载
              </a>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-800"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {!isHome && <div className="h-px bg-background-200/70" />}
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div className="absolute inset-0 bg-foreground-950/40" onClick={() => setMobileOpen(false)}></div>
          <div className="absolute top-16 left-0 right-0 bg-background-50 p-6">
            <div className="flex flex-col gap-4">
              <Link to="/" className="text-base font-medium text-foreground-900 cursor-pointer" onClick={() => setMobileOpen(false)}>首页</Link>
              <p className="text-base font-medium text-foreground-900">分类浏览</p>
              <div className="grid grid-cols-2 gap-2 pl-2">
                {categories.map((cat) => (
                  <Link key={cat.slug} to={`/category/${cat.slug}`} className="flex items-center gap-2 text-sm text-foreground-600 cursor-pointer" onClick={() => setMobileOpen(false)}>
                    <i className={`${cat.icon} text-primary-500`}></i>{cat.name}
                  </Link>
                ))}
              </div>
              <Link to="/about" className="text-base font-medium text-foreground-900 cursor-pointer" onClick={() => setMobileOpen(false)}>关于我们</Link>
              <a href="#download" className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer mt-2" onClick={() => setMobileOpen(false)}>
                立即下载
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}